import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { apiError } from "@/lib/api";
import { Brand } from "@/components/Brand";
import { useBranding } from "@/context/BrandingContext";
import { toast } from "sonner";

export default function Login() {
  const { login, user } = useAuth();
  const { brandTitle } = useBranding();
  const navigate = useNavigate();
  const [email, setEmail] = useState("admin@expressioninteriors.com");
  const [password, setPassword] = useState("admin123");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (user) navigate("/", { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await login(email, password);
      toast.success("Welcome back");
      navigate("/", { replace: true });
    } catch (err) {
      const msg = apiError(err);
      setError(msg);
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:block relative">
        <img
          src="https://images.unsplash.com/photo-1593696140826-c58b021acf8b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBpbnRlcmlvciUyMGNvbnN0cnVjdGlvbnxlbnwwfHx8fDE3ODY0MzI1ODR8MA&ixlib=rb-4.1.0&q=85"
          alt="Modern interior"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-primary/70" />
        <div className="relative z-10 flex flex-col justify-end h-full p-12 text-white">
          <div className="font-heading text-4xl font-extrabold leading-tight">
            Daily Work Management
          </div>
          <p className="mt-4 text-white/80 max-w-md">
            Every project. Every stage. Every update — captured and summarised for
            {brandTitle}, automatically.
          </p>
        </div>
      </div>

      <div className="flex items-center justify-center p-6 bg-background">
        <div className="w-full max-w-sm">
          <div className="mb-8">
            <Brand className="h-16 w-auto" textClassName="font-heading text-2xl font-bold tracking-tight" />
            <p className="text-sm text-muted-foreground mt-3">
              Sign in to the management portal
            </p>
          </div>
          <form onSubmit={submit} className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="email">Email</Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                data-testid="login-email-input"
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password">Password</Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                data-testid="login-password-input"
              />
            </div>
            {error && (
              <p className="text-sm text-destructive" data-testid="login-error">
                {error}
              </p>
            )}
            <Button
              type="submit"
              className="w-full rounded-full"
              disabled={loading}
              data-testid="login-submit-button"
            >
              {loading ? "Signing in…" : "Sign in"}
            </Button>
          </form>
          <p className="text-xs text-muted-foreground mt-6 text-center">
            Admin demo · admin@expressioninteriors.com / admin123
          </p>
        </div>
      </div>
    </div>
  );
}
